<template>
    <div class="flexColumn">
        <module-title title="学习进度"></module-title>
        <div class="personal-learning-box" v-if="isfinish">
            <!-- 培训班tabs开始 -->
            <el-tabs v-model="trainId" @tab-click="changeTrain">
                <el-tab-pane
                    :name="train.id"
                    v-for="train in trainsList"
                    :key="train.id"
                >
                    <el-tooltip
                        class="trainTooltip"
                        :class="{ active: trainId == train.id }"
                        effect="dark"
                        :content="train.trainSignupName"
                        placement="top-start"
                        slot="label"
                    >
                        <el-button>{{ train.trainSignupName }}</el-button>
                    </el-tooltip>
                </el-tab-pane>
            </el-tabs>
            <!-- 培训班tabs结束 -->
            <!-- 学习进度开始 -->
            <div class="learning-news-box">
                <!-- 暂无学习记录开始 -->
                <div class="empty" v-if="empty">
                    <el-empty description="暂无学习记录..."></el-empty>
                </div>
                <!-- 暂无学习记录结束 -->
                <!-- 学习记录列表、分页器开始 -->
                <div class="learning-list-page" v-else>
                    <learn-progress
                        :trainProgress="trainProgress"
                    ></learn-progress>
                    <div class="learning-list">
                        <learning-course>
                            <learning-course-item
                                v-for="item in learningList"
                                :key="item.id"
                                :isFinish="item.status === '1' ? true:false"
                                :courseId="item.course.id"
                                :status="item.status"
                                :playNum="item.playPosition"
                                :totalNum="item.totalDuration"
                                :id="item.chapterVideoRelation.id"
                                :trainId="trainId"
                                :categoryInfoId="categoryInfoId"
                                :isLearn="isLearn"
                            >
                                <img
                                    src="~assets/images/temporary/d_course.png"
                                    slot="img"
                                    class="userImg"
                                    alt=""
                                />
                                <span slot="title"
                                    >《{{ item.course.name }}》</span
                                >
                                <span slot="small_title">{{
                                    videoName(item.videoName)
                                }}</span>
                            </learning-course-item>
                        </learning-course>
                    </div>
                    <div class="block page_box mtop20">
                        <el-pagination
                            layout="prev, pager, next"
                            :page-size="page.size"
                            :background="true"
                            :total="page.total"
                            @current-change="handleCurrentChange"
                        >
                        </el-pagination>
                    </div>
                </div>
                <!-- 学习记录列表、分页器结束 -->
            </div>
            <!-- 学习进度结束 -->
        </div>
    </div>
</template>
<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import LearnProgress from "@/components/common/learnProgress/LearnProgress";
import LearningCourse from "@/components/common/learningCourse/LearningCourse";
import learningCourseItem from "@/components/common/learningCourse/learningCourseItem";
import { PcCookie, Key } from "@/utils/cookie";
import { getSignUpTrains, getStudyRate } from "api/personal";

export default {
    name: "Study",
    components: {
        ModuleTitle,
        LearnProgress,
        LearningCourse,
        learningCourseItem,
    },
    computed: {
        //没有学习记录
        empty() {
            return this.page.total == 0 ? true : false;
        },
        videoName(){
            return function (vName){
                let name = vName.split('.mp4')[0]
                return name
            }
        }
    },
    data() {
        return {
            percentage: 0,
            customColor: "#b21f27",
            itemFinish: false,
            page: {
                current: 1,
                size: 4,
                total: 0,
            },
            sessionId: PcCookie.get(Key.jsessIdKey),
            list: {},
            studyDuration: 0,
            isLearn:'',//课程是否能学习 'true' 能  'false' 不能
            trainProgress: "", //培训班总学习进度
            trainId: "", //培训班id
            trainsList: [], //培训班集合
            learningList: [], //学习进度集合
            isfinish: false,
            categoryInfoId:''
        };
    },
    created() {
        this.fetchSignUpTrains();
        this.fetchStudyRate();
    },
    methods: {
        //切换培训课程
        changeTrain(tab) {
            this.page.current = 1;
            this.train = tab.id;
            this.trainProgress = this.trainsList[tab.index].totalRate;
            this.isLearn = this.trainsList[tab.index].isLearn;
            this.categoryInfoId = tab.categoryInfoId;
            this.fetchStudyRate();
        },
        handleCurrentChange(val) {
            //分页数切换
            this.page.current = val;
            this.fetchStudyRate();
        },
        //获取已报名培训班
        fetchSignUpTrains() {
            getSignUpTrains(this.sessionId).then((res) => {
                const { success, body, msg } = res;
                if (success) {
                    if(body.data.length != 0){
                        this.trainsList = body.data;
                        this.trainId = body.data[0].id;
                        this.categoryInfoId = body.data[0].categoryInfoId;
                        this.trainProgress = body.data[0].totalRate;
                        this.isLearn = body.data[0].isLearn;
                        this.fetchStudyRate();
                    }else{
                        this.isfinish = true;
                    }
                } else {
                    this.$message({
                        message: msg,
                        type: "error",
                    });
                }
            });
        },
        //获取学习进度
        fetchStudyRate() {
            getStudyRate(
                this.sessionId,
                this.trainId,
                this.page.current,
                this.page.size
            ).then((res) => {
                const { body, success, msg } = res;
                if (success) {
                    this.learningList = body.data.list;
                    console.log(this.learningList);
                    this.page.total = body.data.count;
                    this.isfinish = true;
                } else {
                    this.$message({
                        message: msg,
                        type: "error",
                    });
                }
            });
        },
    },
};
</script>
<style>
.personal-learning-box .el-tabs__item {
    padding: 0 8px;
}
</style>
<style scoped>
.empty {
    height: calc(100% - 120px);
    display: flex;
    justify-content: center;
}
.learning-news-box {
    height: calc(100% - 54px);
}
.personal-learning-box {
    flex: 1;
}
.trainTooltip.active {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.trainTooltip {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
}
.flexColumn {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
